<template>
  <div class="content" :class="media">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import ScreenSizeMixin from "src/mixins/ScreenSizeMixin";

export default {
  mixins: [
    ScreenSizeMixin
  ]
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .1s
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active in <2.1.8 */

{
  opacity: 0
}

.content {
  &.sm {
    padding: 30px 0 !important;
  }
}
</style>
